module.exports = __webpack_public_path__ + "static/media/burbank-white.f3d91b2a.svg";